module.exports = __webpack_public_path__ + "static/media/Page-1.72af8cce.svg";